import React, { useRef, useState } from 'react';
import { Formik } from 'formik';
import { useNavigate, Link } from 'react-router-dom'
import { post } from 'src/utils/apiManager';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CFormLabel,
  CRow,
} from '@coreui/react'
import { DefaultInput } from 'src/components/common/input'
import { attributeValidation } from 'src/utils/validator'

function AddAttribute() {

  const navigate = useNavigate()
  const formRef = useRef(null)
  const [isDisable, setIsDisable] = useState(true)

  const submit = async (values) => {
    setIsDisable(false)
   const temp = {
    attributeName_EN: values?.attributeName_EN,
    attributeName_TH: values?.attributeName_TH
   }
   post(
    `/admin/attribute/add`, temp
   ).then((response) => {
    if (response?.status) {
      toast.success(response?.message)
      navigate('/admin/attribute')
    } else {
      toast.error(response?.message)
      setIsDisable(true)
    }
   })
  }

  const onClickReset = () => {
    // Reset Button Function
    formRef.current.resetForm()
  };

  return (
    <>
      <CContainer >
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard className="p-4">
                <CCol xs={12}>
                  <CCardGroup>
                    <CCardBody>
                      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
                      <CRow>
                        <CCol md="11">
                          <h1>Add New Attribute</h1>
                        </CCol>
                        <CCol md="1">
                          <Link className={'btn btn-success mt-2'} style={{ background: '#d3dc40', border: '#d3dc40' }} to={{ pathname: `/admin/attribute` }}>
                            Back
                          </Link>
                        </CCol>
                      </CRow>
                      <Formik
                        initialValues={{
                          attributeName_EN: '',
                          attributeName_TH: '',
                        }}
                        validationSchema={attributeValidation}
                        onSubmit={(values, { setSubmitting }) => {
                          submit(values)
                          setSubmitting(false)
                        }}
                        innerRef={formRef}
                      >
                        {(props) => (
                          <form onSubmit={props.handleSubmit}>
                            <CRow>
                              <CCol md={6} >
                                <CFormLabel>Attribute Name (EN)</CFormLabel>
                                <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                                <DefaultInput
                                  type={"text"}
                                  placeholder={"Attribute Name (EN)"}
                                  value={props?.values?.attributeName_EN}
                                  onChange={props?.handleChange("attributeName_EN")}
                                  onBlur={() => props?.setFieldTouched("attributeName_EN", true)}
                                  error={props?.touched?.attributeName_EN && props?.errors?.attributeName_EN}
                                />
                             
                              </CCol>
                              <CCol md="6">
                                <CFormLabel>Attribute Name (TH)</CFormLabel>
                                <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                                <DefaultInput
                                  type={"text"}
                                  placeholder={"Attribute Name (TH)"}
                                  value={props?.values?.attributeName_TH}
                                  onChange={props?.handleChange("attributeName_TH")}
                                  onBlur={() => props?.setFieldTouched("attributeName_TH", true)}
                                  error={props?.touched?.attributeName_TH && props?.errors?.attributeName_TH}
                                />
                              </CCol>
                            </CRow>
                            <CRow>
                              <CCol md="2">
                                <button
                                  type="submit"
                                  className={'btn btn-success mt-2'}
                                  disabled={!isDisable || props?.isSubmitting}
                                >
                                  Submit
                                </button>
                              </CCol>
                              <CCol md="2">
                                <button
                                  type="button"
                                  className={'btn btn-warning mt-2'}
                                  onClick={() => onClickReset(props.isSubmitting)}
                                >
                                  Reset
                                </button>
                              </CCol>
                              <CCol md="3"></CCol>
                            </CRow>
                          </form>
                        )}
                      </Formik>
                    </CCardBody>
                  </CCardGroup>
                </CCol>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </>
  )
}

export default AddAttribute
